import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLocation, Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

type RequireAuthProps = {
  children: React.ReactNode
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { t } = useTranslation()
  const auth = useAuth()
  const location = useLocation()

  if (!auth.initialized) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '40vh', gap: 2 }}>
        <CircularProgress color="primary" />
        <Typography variant="body1" color="text.secondary">{t('auth.checking')}</Typography>
      </Box>
    )
  }

  if (!auth.user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}

export default RequireAuth

